import {
  Field as HeadlessField,
  type FieldProps as HeadlessFieldProps,
} from "@headlessui/react";
import { classNames } from "../../utils/classNames";

export function CheckboxField({ className, ...props }: HeadlessFieldProps) {
  return (
    <HeadlessField
      data-slot="field"
      {...props}
      className={classNames(
        // Base layout
        "grid grid-cols-[1.125rem_1fr] items-center gap-x-3 gap-y-1 sm:grid-cols-[1rem_1fr]",

        // Control layout
        "[&>[data-slot=control]]:col-start-1 [&>[data-slot=control]]:row-start-1 [&>[data-slot=control]]:justify-self-center",

        // Label layout
        "[&>[data-slot=label]]:col-start-2 [&>[data-slot=label]]:row-start-1 [&>[data-slot=label]]:justify-self-start",

        // Description layout
        "[&>[data-slot=description]]:col-start-2 [&>[data-slot=description]]:row-start-2",

        // Error layout
        "[&>[data-slot=error]]:col-[1_/_3] [&>[data-slot=error]]:row-start-3",

        // With description
        "[&_[data-slot=label]]:has-[[data-slot=description]]:font-medium",

        className,
      )}
    />
  );
}
